<template>
  <div
    :class="[
      `f-checkbox`,
      `f-checkbox--${size}`, 
      {
        'is-selected': currentValue,
        'is-disabled': disabled,
        'is-readonly': readonly,
        'is-focus': focus,
      }
    ]"
  >
    <input
      ref="field"
      type="checkbox"
      class="f-checkbox__inner"
      v-model="currentValue"
      @change="handleChange"
      @focus="handleFocus"
      @blur="handleBlur"
      :readonly="readonly"
      :disabled="disabled"
    >

    <i class="f-checkbox__icon uil uil-check"></i>
  </div>
</template>

<script>
  import { ref, watch, computed, nextTick } from 'vue'

  export default {
    props: {
      modelValue: {
        type: Boolean,
        required: true,
      },

      size: {
        type: String,
        default: 'normal',
      },

      disabled: {
        type: Boolean,
        default: false,
      },

      readonly: {
        type: Boolean,
        default: false,
      },
    },

    setup (props, context) {
      const currentValue = ref(!!props.modelValue)
      const focus = ref(false)
      const field = ref(null)

      function handleChange (event) {
        context.emit('update:modelValue', event.target.checked)
      } 
      
      function handleFocus (event) {
        focus.value = true 

        context.emit('focus', event)
      } 
      
      function handleBlur (event) {
        focus.value = false 

        context.emit('blur', event)
      }

      const isSelected = computed(() => !!field.value?.checked)
      
      watch(() => props.modelValue, newValue => {
        if (newValue == currentValue.value) {
          return
        }

        currentValue.value = newValue
      }, { immediate: false })

      return {
        currentValue,
        field,
        focus,
        handleChange,
        handleFocus,
        handleBlur,
        isSelected,
      }
    },
  }
</script>

<style lang="scss">
  @import "@styles/variables.scss";
  
  .f-checkbox {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: $gray-lighter;
    border-radius: 3px;
    transition: box-shadow 0.3s ease, background-color 0.3s ease;
    cursor: pointer;

    &:hover, &.is-focused {
      box-shadow: 0 0px 1px 0 rgba(102, 166, 255, 0.3);
    }

    &.is-selected {
      background-color: $white;

      .f-checkbox__icon {
        opacity: 1;
      }

      &.is-disabled {
        .f-checkbox__icon {
          color: $gray;
        }
      }
    }

    &.is-disabled {
      background-color: $gray-lighter;
    }

    &.is-readonly {
      box-shadow: 0 1px 1px 0 rgba($color-disabled, 0.3);

      .f-checkbox__inner {       
        &:hover {
          cursor: not-allowed;
        }
      }
    }

    .f-checkbox__inner {
      position: absolute;
      height: 100%;
      width: 100%;
      opacity: 0;
      z-index: 3;
      border: none;
      outline: none;
      background-color: transparent;
      cursor: pointer;
    }

    .f-checkbox__icon {
      opacity: 0;
      color: $color-success;
      transition: opacity 0.3s ease;
    }

    &.f-checkbox--small {
      height: 0.85rem;
      width: 0.85rem;
    }

    &.f-checkbox--normal {
      height: 1rem;
      width: 1rem;
    }

    &.f-checkbox--medium {

    }

    &.f-checkbox--large {

    }
  }

  .f-checkbox + .f-checkbox {
    margin-left: 0.5rem;
  }
</style>